import { FirebaseAuthentication } from 'services/firebase';

const logout = async () => {
  await FirebaseAuthentication().signOut();
};

export default logout;
